/* ALCO · Tarjeta de producto en TODA la tienda (9-oct-2026, tema «Respaldo de FABLE»).
   Comportamiento de snippets/alco-tarjeta-catalogo.liquid cuando la pinta card-product (tarjetas .acx--g):
   tira de fotos, cantidad (+/−, mínimo y formato de venta), total, descuento por cantidad, copiar SKU y
   «Lista de resurtidos» (se guarda en ESTE navegador con la llave alco-mi-lista, la misma del catálogo).
   El botón «Agregar al carrito» lo maneja product-form.js del tema (agrega y abre el cajón).
   Todo va por delegación en document: sirve también para tarjetas que llegan después (filtros de la
   colección, «También te puede gustar»). Las tarjetas de la sección del catálogo (alco-cat-productos)
   NO tienen .acx--g y las sigue manejando su propia sección.
   Lo carga layout/theme.liquid sólo con el ajuste «Usar la tarjeta nueva en toda la tienda». */
(function () {
  if (window.alcoTarjetaTienda) return;
  window.alcoTarjetaTienda = true;

  var SEL = '.acx--g';
  function tarjeta(el) { return el && el.closest ? el.closest(SEL) : null; }
  var vivo = null;
  function avisa(t) {
    if (!vivo) {
      vivo = document.createElement('span');
      vivo.className = 'visually-hidden';
      vivo.setAttribute('aria-live', 'polite');
      document.body.appendChild(vivo);
    }
    vivo.textContent = '';
    setTimeout(function () { vivo.textContent = t; }, 30);
  }
  function dinero(cent) { return '$ ' + (cent / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  /* ---------- Fotos: tira de miniaturas con flechas ‹ › ---------- */
  function fotoActual(card) {
    var tr = card.querySelector('.acx__track');
    return Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth));
  }
  function marca(card, k) {
    var ths = card.querySelectorAll('.acx__th'), tira = card.querySelector('.acx__ths');
    ths.forEach(function (b, j) { b.setAttribute('aria-current', j === k ? 'true' : 'false'); });
    Array.prototype.forEach.call(card.querySelector('.acx__track').children, function (sl, j) { sl.setAttribute('aria-hidden', j === k ? 'false' : 'true'); });
    var b = ths[k];
    if (!b || !tira) return;
    if (b.offsetLeft < tira.scrollLeft) tira.scrollLeft = b.offsetLeft - 4;
    else if (b.offsetLeft + b.offsetWidth > tira.scrollLeft + tira.clientWidth) tira.scrollLeft = b.offsetLeft + b.offsetWidth - tira.clientWidth + 4;
  }
  function irFoto(card, k) {
    var tr = card.querySelector('.acx__track');
    var n = tr.children.length;
    k = (k + n) % n;
    tr.scrollTo({ left: k * tr.clientWidth, behavior: 'smooth' });
    marca(card, k);
  }
  // El scroll de un elemento no burbujea, pero sí pasa por document en la fase de captura.
  document.addEventListener('scroll', function (e) {
    var tr = e.target;
    if (!tr || !tr.classList || !tr.classList.contains('acx__track')) return;
    var card = tarjeta(tr);
    if (!card || !card.querySelector('.acx__thumbs')) return;
    var k = fotoActual(card);
    if (card._acxFoto !== k) { card._acxFoto = k; marca(card, k); }
  }, { capture: true, passive: true });

  /* ---------- Cantidad, total y descuento por cantidad ---------- */
  function rangoQty(inp) {
    var mn = Number(inp.min) || 1, st = Number(inp.step) || 1, mx = inp.max ? Number(inp.max) : Infinity;
    return { mn: mn, st: st, mx: mx };
  }
  function niveles(card) {
    if (!card.dataset.desc) return [];
    return card.dataset.desc.split(',').map(function (p) { var a = p.split(':'); return { min: Number(a[0]), pct: Number(a[1]) }; })
      .filter(function (t) { return t.min > 0 && t.pct > 0; });
  }
  function descuento(card, q) {
    var el = card.querySelector('[data-dq-tot]');
    var ts = niveles(card);
    if (!el || !ts.length) return;
    var mejor = null;
    ts.forEach(function (t) { if (q >= t.min && (!mejor || t.pct > mejor.pct)) mejor = t; });
    card.querySelectorAll('.acx__dq-tb tr[data-min]').forEach(function (tr) { tr.classList.toggle('is-on', !!mejor && Number(tr.dataset.min) === mejor.min); });
    el.textContent = '';
    if (mejor) {
      var base = Number(card.dataset.price) || 0;
      var con = Math.round(base * (100 - mejor.pct) / 100) * q;
      el.appendChild(document.createTextNode('Con ' + q + ' pz (−' + mejor.pct + '%): '));
      var b = document.createElement('b'); b.textContent = dinero(con) + ' mxn'; el.appendChild(b);
    } else {
      var primero = ts.reduce(function (a, t) { return t.min < a.min ? t : a; });
      el.textContent = 'Desde ' + primero.min + ' pz obtienes −' + primero.pct + '%.';
    }
  }
  function total(card, q) {
    // Lo que cobra el carrito: precio × cantidad (con precios por volumen REALES de Shopify si los hay).
    var precio = Number(card.dataset.price) || 0;
    if (card.dataset.breaks) card.dataset.breaks.split(',').forEach(function (p) { var a = p.split(':'); if (q >= Number(a[0])) precio = Math.min(precio, Number(a[1])); });
    var n = card.querySelector('[data-n]'), tot = card.querySelector('[data-total]');
    if (n) n.textContent = q;
    if (tot) tot.textContent = dinero(precio * q) + ' mxn';
    descuento(card, q);
  }
  function fijaQty(inp, q) {
    var r = rangoQty(inp);
    q = Math.round(Number(q) || r.mn);
    if (q < r.mn) q = r.mn;
    if (q > r.mx) q = r.mx;
    if (r.st > 1) q = r.mn + Math.round((q - r.mn) / r.st) * r.st;
    if (q > r.mx) q -= r.st;
    if (q < r.mn) q = r.mn;
    inp.value = q;
    total(tarjeta(inp), q);
  }
  function esQty(el) { return el && el.classList && el.classList.contains('acx__qi') && tarjeta(el); }
  // Mientras escribe sólo se actualiza el total; al salir del campo se ajusta al mínimo/máximo.
  document.addEventListener('input', function (e) {
    var inp = e.target;
    if (!esQty(inp)) return;
    var q = Math.round(Number(inp.value)), r = rangoQty(inp);
    if (q >= r.mn && q <= r.mx) total(tarjeta(inp), q);
  });
  document.addEventListener('change', function (e) { if (esQty(e.target)) fijaQty(e.target, e.target.value); });
  // Antes de que product-form.js mande al carrito (fase de captura): la cantidad dentro del rango.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector || !tarjeta(f)) return;
    var inp = f.querySelector('.acx__qi');
    if (inp) fijaQty(inp, inp.value);
  }, true);

  /* ---------- Lista de resurtidos (en este navegador) ---------- */
  var CLAVE = 'alco-mi-lista';
  function leer() { try { var a = JSON.parse(localStorage.getItem(CLAVE) || '[]'); return Array.isArray(a) ? a : []; } catch (e) { return []; } }
  function guardar(a) { try { localStorage.setItem(CLAVE, JSON.stringify(a)); } catch (e) { /* sin almacenamiento */ } }
  var lista = leer();
  var panel = null, pill = null;
  function enLista(id) { return lista.some(function (x) { return String(x.id) === String(id); }); }
  // En la plantilla del catálogo, la sección ya trae su botón y su panel: ahí no se duplican.
  function catalogoConLista() { return !!document.querySelector('.acp [data-abrir-lista]'); }
  function hayBotonLista() { return !!document.querySelector(SEL + ' [data-lista]'); }
  function colorDe() {
    var c = document.querySelector(SEL);
    return c ? (c.style.getPropertyValue('--azul') || '').trim() : '';
  }
  function armaPill() {
    if (pill || catalogoConLista()) return;
    pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'acl-pill';
    pill.hidden = true;
    pill.setAttribute('data-abrir-lista-g', '');
    pill.setAttribute('aria-haspopup', 'dialog');
    pill.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 3.5h9l3.5 3.5v13.5H6z"/><path d="M9 11h6M9 14.5h6M9 7.5h3"/></svg>Lista de resurtidos <span data-cuenta-g>0</span>';
    var col = colorDe();
    if (col) pill.style.setProperty('--azul', col);
    document.body.appendChild(pill);
  }
  function armaPanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'acl acl--g';
    panel.hidden = true;
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-labelledby', 'acl-t-g');
    panel.innerHTML =
      '<button type="button" class="acl__ov" data-cerrar-lista-g aria-label="Cerrar la lista de resurtidos"></button>' +
      '<div class="acl__pn">' +
        '<div class="acl__hd"><h2 id="acl-t-g">Lista de resurtidos</h2><button type="button" class="acl__x" data-cerrar-lista-g aria-label="Cerrar">×</button></div>' +
        '<p class="acl__nota">Se guarda en este navegador. Junta aquí lo que resurtes seguido y agrégalo al carrito de una vez.</p>' +
        '<ul class="acl__ls" role="list" data-items></ul>' +
        '<div class="acl__ft">' +
          '<p class="acl__msg" data-msg hidden>.</p>' +
          '<button type="button" class="acl__todo" data-agregar-todo-g>Agregar todo al carrito</button>' +
          '<button type="button" class="acl__vac" data-vaciar-g>Vaciar lista</button>' +
        '</div>' +
      '</div>';
    var col = colorDe();
    if (col) panel.style.setProperty('--azul', col);
    document.body.appendChild(panel);
    return panel;
  }
  /* Cantidad para el carrito: el mínimo / formato de venta de la tarjeta (si está en esta página, el vigente). */
  function cantLista(x) {
    var c = document.querySelector(SEL + '[data-variant="' + String(x.id).replace(/[^0-9]/g, '') + '"]');
    var q = c ? Number(c.dataset.qmin) : Number(x.q);
    return q > 0 ? Math.round(q) : 1;
  }
  function pintaPanel() {
    if (!panel) return;
    var ul = panel.querySelector('[data-items]');
    ul.textContent = '';
    if (!lista.length) {
      var li0 = document.createElement('li'); li0.className = 'acl__vacia';
      li0.textContent = 'Tu lista de resurtidos está vacía. Toca «Agregar a lista de resurtidos» en un producto.';
      ul.appendChild(li0);
    }
    lista.forEach(function (x) {
      var li = document.createElement('li'); li.className = 'acl__it';
      var im;
      if (x.img) { im = document.createElement('img'); im.alt = ''; im.loading = 'lazy'; im.src = x.img; }
      else { im = document.createElement('span'); im.className = 'acl__sin'; }
      li.appendChild(im);
      var dv = document.createElement('span');
      var a = document.createElement('a'); a.href = x.u || '#'; a.textContent = x.t || 'Producto'; dv.appendChild(a);
      var q = cantLista(x);
      var sm = document.createElement('small');
      sm.textContent = dinero(x.p || 0) + ' mxn' + (q > 1 ? ' · se agregan ' + q + ' pz' : '') + (x.d === false ? ' · Agotado' : '');
      dv.appendChild(sm);
      li.appendChild(dv);
      var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'acl__rm'; rm.textContent = 'Quitar'; rm.setAttribute('data-quitar-g', x.id);
      li.appendChild(rm);
      ul.appendChild(li);
    });
    panel.querySelector('[data-agregar-todo-g]').disabled = !lista.some(function (x) { return x.d !== false; });
  }
  function pinta() {
    document.querySelectorAll(SEL).forEach(function (card) {
      var on = enLista(card.dataset.variant);
      card.querySelectorAll('[data-lista]').forEach(function (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        var l = b.querySelector('[data-lbl]');
        if (l) l.textContent = on ? 'En tu lista de resurtidos ✓' : 'Agregar a lista de resurtidos';
      });
    });
    if (lista.length && (hayBotonLista() || pill)) armaPill();
    if (pill) {
      // En la vista previa de Shopify la barra negra de abajo lo taparía: se sube.
      pill.classList.toggle('acl-pill--alta', !!document.getElementById('PBarNextFrameWrapper'));
      pill.hidden = !lista.length;
      var c = pill.querySelector('[data-cuenta-g]');
      if (c) c.textContent = lista.length;
    }
    pintaPanel();
  }
  function alterna(card) {
    var id = card.dataset.variant;
    if (enLista(id)) {
      lista = lista.filter(function (x) { return String(x.id) !== String(id); });
      avisa('Quitado de la lista de resurtidos');
    } else {
      lista.push({ id: id, t: card.dataset.title, u: card.dataset.url, img: card.dataset.img, p: Number(card.dataset.price) || 0, d: card.dataset.disponible === 'true', q: Number(card.dataset.qmin) || 1 });
      avisa('Guardado en la lista de resurtidos');
    }
    guardar(lista);
    pinta();
  }
  var antes = null;
  function abrir() {
    armaPanel(); pintaPanel();
    antes = document.activeElement;
    panel.hidden = false;
    document.body.style.overflow = 'hidden';
    var x = panel.querySelector('.acl__x'); if (x) x.focus();
  }
  function cerrar() {
    if (!panel || panel.hidden) return;
    panel.hidden = true;
    document.body.style.overflow = '';
    if (antes && antes.focus) antes.focus();
  }
  function msg(t) { var m = panel.querySelector('[data-msg]'); m.textContent = t || '.'; m.hidden = !t; }
  function agregarTodo(btn) {
    var items = lista.filter(function (x) { return x.d !== false; }).map(function (x) { return { id: Number(x.id), quantity: cantLista(x) }; });
    if (!items.length) return;
    var cart = document.querySelector('cart-drawer');
    var cuerpo = { items: items };
    if (cart && cart.getSectionsToRender) { cuerpo.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); cuerpo.sections_url = window.location.pathname; }
    btn.disabled = true; msg('');
    var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(cuerpo) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { msg(res.description || res.message || 'No se pudo agregar.'); return; }
        cerrar();
        if (cart && res.sections) { cart.classList.remove('is-empty'); cart.renderContents(res); }
        else window.location = (window.routes && window.routes.cart_url) || '/cart';
      })
      .catch(function () { msg('No se pudo agregar. Intenta de nuevo.'); })
      .finally(function () { btn.disabled = false; });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') cerrar(); });

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('button, a') : null;
    if (!t) return;
    // Panel y botón flotante de la lista.
    if (t.hasAttribute('data-abrir-lista-g')) { abrir(); return; }
    if (t.hasAttribute('data-cerrar-lista-g')) { cerrar(); return; }
    if (t.hasAttribute('data-quitar-g')) { var qid = t.getAttribute('data-quitar-g'); lista = lista.filter(function (x) { return String(x.id) !== String(qid); }); guardar(lista); pinta(); return; }
    if (t.hasAttribute('data-vaciar-g')) { lista = []; guardar(lista); pinta(); return; }
    if (t.hasAttribute('data-agregar-todo-g')) { agregarTodo(t); return; }
    // Tarjeta.
    var card = tarjeta(t);
    if (!card) return;
    if (t.classList.contains('acx__tn')) irFoto(card, fotoActual(card) + Number(t.dataset.paso));
    else if (t.classList.contains('acx__th')) irFoto(card, Number(t.dataset.i));
    else if (t.classList.contains('acx__qb')) { var inp = card.querySelector('.acx__qi'); if (inp) fijaQty(inp, Number(inp.value) + Number(t.dataset.q) * (Number(inp.step) || 1)); }
    else if (t.classList.contains('acx__copy')) {
      var txt = t.dataset.copiar;
      var ok = function () { t.classList.add('is-ok'); t.title = 'Copiado'; avisa('SKU ' + txt + ' copiado'); setTimeout(function () { t.classList.remove('is-ok'); t.title = 'Copiar SKU'; }, 1600); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(ok, function () {});
      else { var ta = document.createElement('textarea'); ta.value = txt; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); ok(); } catch (er) { /* sin portapapeles */ } ta.remove(); }
    }
    else if (t.hasAttribute('data-lista')) alterna(card);
  });

  window.addEventListener('storage', function (e) { if (e.key === CLAVE) { lista = leer(); pinta(); } });

  /* Tarjetas que llegan después (filtros, recomendaciones): se pinta su estado de la lista. */
  var pendiente = false;
  function alCambiar() {
    if (pendiente) return;
    pendiente = true;
    setTimeout(function () { pendiente = false; pinta(); }, 120);
  }
  function inicia() {
    pinta();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var ns = muts[i].addedNodes;
          for (var j = 0; j < ns.length; j++) {
            var n = ns[j];
            if (n.nodeType === 1 && (n.matches(SEL) || n.querySelector(SEL))) { alCambiar(); return; }
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', inicia);
  else inicia();
})();
